import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { MatDialog } from "@angular/material";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { CommonService } from '../../services/common/common.service';
import { GeoFilterDialog } from '../../components/graphs/geo-map/geo-map.component';
import { GroupService } from "../../../shared/services/group/group.service";
import { WidgetService } from "../../../shared/services/widget/widget.service";
declare var webix: any;

@Component({ selector: 'app-expand-toggle', templateUrl: './expand-toggle.component.html', styleUrls: ['./expand-toggle.component.scss'],changeDetection:ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None })
export class ExpandToggleComponent implements OnInit {
  @Input('header') header: string;
  @Input('border') border: boolean;
  @Input('hideBackGround') hideBackGround: boolean;
  @Input('showEdit') showEdit: string;
  @Input('showDelete') showDelete: string;
  @Input('showExpand') showExpand: string;
  @Input('showGroupExport') showGroupExport: boolean;
  @Input('boxStyle') boxStyle: any;
  @Input('widgetId') widgetId: string;
  @Input('widgetType') widgetType: string;
  @Input('wigetData') wigetData: any;
  @Input('groupId') groupId: any;

  expand: boolean = false;
  isPlay: number = 0;
  expandStyle: any = {};
  hasData: boolean = false;
  allowInGroupExport = false;
  
  constructor(public router: Router, public activatedRoute: ActivatedRoute, private commonService: CommonService, public dialog: MatDialog, private groupService: GroupService, private widgetService: WidgetService) {

  }

  ngOnInit() {
    this.checkAdevrtisingId();
    this
      .activatedRoute
      .queryParams
      .subscribe((params: Params) => {
        if (params.play) {
          this.isPlay = 1;
        }
      });

    if (!this.boxStyle) {
      this.boxStyle = {
        boxColor: "",
        valueColor: "",
        labelColor: "",
        borderThickness: 0,
        borderColor: ""
      }
    }

    if (this.boxStyle.boxColor) {
      this.expandStyle['backgroundColor'] = this.boxStyle.boxColor;
    }
    if (this.boxStyle.borderThickness > 0 && this.boxStyle.borderColor) {
      this.expandStyle['border'] = '' + this.boxStyle.borderThickness + 'px solid ' + this.boxStyle.borderColor + '';
    }
  }

  openGeoFilterDialog(isEdit: any) {
    if (isEdit) {
      let data = this.wigetData.dataFilter.map((obj) => {
        return obj.geoConfig;
      });
      data = {
        widgetId: this.widgetId,
        groupId: this.groupId,
        isEdit: isEdit,
        ...(data.length > 0 ? data[0] : { geoFilterType: "localfilter" })
      }
      this.dialog.open(GeoFilterDialog, {
        data: data,
        height: "auto",
        width: "800px",
        panelClass: "full-modal",
        disableClose: true
      });
    } else {
      this.widgetService.listSavedQuestion(this.widgetId).subscribe(r => {
        let data = {
          widgetId: this.widgetId,
          groupId: this.groupId,
          geoFilterType: "localfilter",
          listQuestion: r
        }
        this.dialog.open(GeoFilterDialog, {
          data: data,
          height: "auto",
          width: "800px",
          panelClass: "full-modal",
          disableClose: true
        });
      });
    }
  }

  checkAdevrtisingId() {
    this.commonService.getAction().subscribe(data => {
      if (["Advertising_Id"].includes(data.action)) {
        if (this.widgetId === data.data.widgetId)
          this.hasData = data.data.isAdvertising_Id;
      }
    });
  }

  exportAdvCsv() {
    this.commonService.connectIdxDB().then(dbConn => {
      this.commonService.readIdWidget(dbConn, this.widgetId).then(res => {
        res = res['_data'];
        let _advs = res['dataFilter'] && res['dataFilter'].length > 0 && res['dataFilter'][0].data;
        if (_advs.length > 0) {
          let _alladvs = _advs.map(el => { return el.advertisingid });
          _alladvs = _alladvs.filter((v, i, a) => a.indexOf(v) === i);
          let csvContent = "data:text/csv;charset=utf-8,"
            + _alladvs.join("\n");
          var encodedUri = encodeURI(csvContent);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", this.header + ".csv");
          document.body.appendChild(link);
          link.click();
        }
      });
    });
  }

  expandToggle() {
    this.expand = !this.expand;

    //expand
    if (this.expand) {
      document.documentElement.className += " toggle-expanded";
    } else {
      // document.documentElement.className.replace(/(?:^|\s)expanded(?!\S)/, '');
      document.documentElement.className = document
        .documentElement
        .className
        .replace('toggle-expanded', '');
    }

    setTimeout(() => {
      var resizeEvent = window
        .document
        .createEvent('UIEvents');
      resizeEvent.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(resizeEvent);
    }, 100);

    event.preventDefault();

    if (this.expand) {
      this.commonService.sendAction("showDesignerPivot", false);
    } else {
      this.commonService.sendAction("showDesignerPivot", true);
    }
  }

  // expandToggleGroup(){

  // }

  onAllowExportChange() {
    this.updateExportGroup.emit({ widgetId: this.widgetId, allowInGroupExport: this.allowInGroupExport });
  }

  exportExcel() {
    let name = this.wigetData.kpiType == 'comparison' || (this.wigetData.kpiType == 'compareDate' &&  this.wigetData.compareDateConfig.compareType == 'daily') ? "table" : "pivotTable";
    webix.toExcel((name + this.widgetId), {
      filename: this.wigetData.title,
      styles: true,
      filterHTML: false
    });
  }
  exportPDF() {    
    let name = this.wigetData.kpiType == 'comparison' || (this.wigetData.kpiType == 'compareDate' &&  this.wigetData.compareDateConfig.compareType == 'daily') ? "table" : "pivotTable";
    webix.toPDF((name + this.widgetId), {
      filename: this.wigetData.title,
      autowidth: true,
      orientation: "landscape",
      styles: true,
      filterHTML: false
    });
  }

  resetConfig() {
    this.commonService.sendAction("resetTableConfig", { widgetId: this.widgetId });
  }

  @Output() update: EventEmitter<any> = new EventEmitter<any>();
  @Output() delete: EventEmitter<any> = new EventEmitter<any>();
  @Output('updateExportGroup') updateExportGroup: EventEmitter<any> = new EventEmitter();
}


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/directives/expand-toggle/expand-toggle.component.ts